/* eslint-disable spire/export-styles */
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

export interface CategoryNameStyles {
    titleText?: TypographyProps;
}

export const categoryNameStyles: CategoryNameStyles = {
    titleText: {
        variant: "h1",
        css: css`
            font-size: 32px;
        `,
    },
};

const CategoryName = ({ category, currentPage }: Props) => {
    if (!category) {
        return null;
    }

    return (
        <Typography
            {...categoryNameStyles.titleText}
            variant="h1"
            data-test-selector={`categoryName_${category.shortDescription ?? category.name}`}
        >
            {category.shortDescription ?? category.name}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCategory(CategoryName)),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
